import type { Participant } from "../types";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { Users } from "lucide-react";
import { useI18n } from "../i18n";

interface ParticipantsPanelProps {
  participants: Participant[];
  currentId?: string;
}

export default function ParticipantsPanel({
  participants,
  currentId,
}: ParticipantsPanelProps) {
  const { t } = useI18n();
  const [collapsed, setCollapsed] = useLocalStorage(
    "panel-participants-collapsed",
    false,
  );

  return (
    <section className="panel" data-component="ParticipantsPanel">
      <h3
        className="panel-header"
        data-collapsed={collapsed || undefined}
        onClick={() => setCollapsed(!collapsed)}
      >
        <Users size={14} className="inline-block mr-1 align-[-2px]" /> {t('participants.title')}
        ({participants.filter((p) => p.online).length}/{participants.length})
      </h3>
      {!collapsed && (
        <div className="panel-content">
          <div className="participants-list">
            {participants.map((p) => (
              <div
                key={p.id}
                className={`participant-item ${p.id === currentId ? "self" : ""}`}
              >
                <span
                  className={`participant-status ${p.online ? "online" : "offline"}`}
                >
                  {p.online ? "●" : "○"}
                </span>
                <span className="participant-name">{p.name}</span>
                <span className="participant-role">
                  {p.role === "gm" ? "GM" : ""}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
